module.exports = __webpack_public_path__ + "img/regular_cycle_6.11e2951a.jpg";